module.exports = __webpack_public_path__ + "images/accents/accent-timeline-51179b96f48d38eddf6b1f045a85dd72.webp";